export default __webpack_public_path__ + "static/media/zoomsamlguide.15954fc2.png";